import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Sun` — sun with rays.
 * Aria label:    Sun
 * Family:        weather
 * Related:       moon, cloud, cloud-sun, cloud-moon, cloud-rain, cloud-snow
 * Canonical use: sun glyph in weather UI surfaces.
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Sun.
 *
 */
export const Sun = forwardRef(function Sun(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("circle", { cx: "12", cy: "12", r: "4" }), _jsx("path", { d: "M12 3 v2" }), _jsx("path", { d: "M12 19 v2" }), _jsx("path", { d: "M5 5 l1.5 1.5" }), _jsx("path", { d: "M17.5 17.5 l1.5 1.5" }), _jsx("path", { d: "M3 12 h2" }), _jsx("path", { d: "M19 12 h2" }), _jsx("path", { d: "M5 19 l1.5 -1.5" }), _jsx("path", { d: "M17.5 6.5 l1.5 -1.5" })] }));
});
//# sourceMappingURL=sun.js.map